
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13622",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13622",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1340",
  "client-types": "static-1.524",
  "data-fetching-client": "static-1.10177",
  "foundations-components": "static-1.8854",
  "foundations-components-legacy": "static-1.1879",
  "foundations-theming": "static-1.5043",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.96",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8583",
  "hub-http-shared-msw-handlers": "static-1.11010",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12031",
  "I18n": "static-7.1726",
  "jasmine-runner": "static-1.7000",
  "marketplace-discovery-studio-lib": "static-1.1011",
  "marketplace-storefront-base": "static-1.13685",
  "quartz": "static-1.7768",
  "react-dlb": "static-1.97",
  "react-rhumb": "static-1.17281",
  "reactive-variable-buffer-atom": "static-1.3391",
  "reporting-testing-lib": "static-1.11586",
  "reselect": "static-3.20",
  "settings-ui-lib": "static-1.13074",
  "SharedI18nStrings": "static-1.191",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7944",
  "ui-addon-i18n": "static-1.11690",
  "ui-addon-react-router-dom": "static-1.10070",
  "unified-auth": "static-1.1384",
  "unified-auth-core-lib": "static-1.1666",
  "usage-tracker": "static-1.7886",
  "usage-tracker-core": "static-1.7736",
  "customer-data-property-utils": "static-1.8601",
  "hub-http": "static-1.6745",
  "integrations-lib": "static-1.17568",
  "marketplace-ui-common": "static-1.21164",
  "marketplace-ui-install": "static-1.1150",
  "property-management-iframe": "static-1.14622",
  "quartz-config": "static-1.1546",
  "quartz-core": "static-1.6987",
  "quartz-routing": "static-1.1198",
  "quick-fetch": "static-1.4268",
  "react": "static-7.206",
  "rpc-client-utils": "static-1.5207",
  "ts-schema": "static-1.4435",
  "ui-universal-auth": "static-1.9870",
  "UIComponents": "static-3.8977",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.529",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.4045",
  "quartz-webpack": "static-1.3992",
  "bend-plugin-quartz-routing": "static-1.846",
  "ai-components-ui-library": "static-1.10137",
  "codemirror": "static-5.109",
  "foundations-assets": "static-1.5431",
  "hs-browser-apis": "static-1.18",
  "pulse": "static-1.1211",
  "react-codemirror": "static-1.11183",
  "ui-extensions-preview-lib": "static-1.1125",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5123",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2759",
  "framer-motion": "static-1.87",
  "hs-story-utils": "static-1.9966",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.124",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5721",
  "react-virtualized": "static-2.115",
  "StyleGuideUI": "static-3.522",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3271",
  "ui-fonts": "static-1.1293",
  "ui-images": "static-2.1297",
  "bend-plugin-foundations-theming": "static-1.3526",
  "foundations-theming-base": "static-1.4028",
  "stylex": "static-1.50",
  "HeadJS": "static-2.839",
  "hs-test-utils-bend-plugin": "static-1.3694",
  "msw": "static-1.106",
  "msw-config": "static-1.45",
  "testing-library": "static-1.168",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4846",
  "ui-addon-video-player": "static-1.9163",
  "ai-rendering-library": "static-1.11557",
  "chirp-fetch": "static-1.2441",
  "connections-embed-lib": "static-1.1854",
  "copilot-toolkit": "static-1.12274",
  "feedback-loader": "static-1.30155",
  "laboratory-lib": "static-3.7690",
  "marketplace-embed": "static-1.23318",
  "marketplace-ui-details": "static-1.11059",
  "marketplace-ui-reviews": "static-1.21119",
  "marketplace-ui-tracking": "static-1.15334",
  "sanitize-text": "static-1.8698",
  "usage-tracker-multi": "static-1.6300",
  "usage-tracker-session-replay": "static-1.5572",
  "beacon-keepalive-queue": "static-1.244",
  "quartz-head": "static-1.1433",
  "web-vitals": "static-1.22",
  "apollo-link-hub-http": "static-2.5130",
  "immer": "static-1.107",
  "immerable": "static-1.4686",
  "highcharts": "static-8.118",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2904",
  "reporting-data": "static-1.69653",
  "cssUtils": "static-1.1163",
  "flux-actions": "static-1.384",
  "react-colorpicker": "static-2.10751",
  "react-dnd-compat": "static-1.5152",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10914",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7876",
  "icons": "static-2.717",
  "marketplace-ui-apps-core": "static-1.19696",
  "storybook-react": "static-1.47",
  "trellis-story-utils": "static-1.5037",
  "foundations-components-test-utils": "static-1.6337",
  "quartz-i18n": "static-1.1443",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.854",
  "ads-unified-auth-lib": "static-1.2318",
  "ai-mcp-auth-lib": "static-1.87",
  "cohere-settings-lib": "static-1.10554",
  "custom-vendor-connection-lib": "static-1.434",
  "gemini-settings-lib": "static-1.9904",
  "google-sheets-integration-lib": "static-1.1453",
  "microsoft-drive-auth-lib": "static-1.651",
  "slack-ui-library": "static-1.10944",
  "surveymonkey-integration-lib": "static-1.967",
  "x-ai-settings-lib": "static-1.10612",
  "fsm": "static-1.4302",
  "customer-data-objects": "static-1.8257",
  "property-translator": "static-1.5916",
  "hs-locale-management": "static-1.444",
  "frontend-preferences-client": "static-1.8464",
  "hs-promise-utils": "static-1.6133",
  "hubspot-apollo-client": "static-1.5417",
  "integrations-error-boundary-lib": "static-1.14983",
  "integrations-tracking-lib": "static-1.6170",
  "native-integrations-shared-strings": "static-1.8300",
  "sanitize": "static-1.5009",
  "superstore": "static-1.5296",
  "ui-shepherd-react": "static-3.10829",
  "ai-settings-ui-library": "static-1.8692",
  "hub-http-janus": "static-1.921",
  "hubspotter-http": "static-1.5013",
  "immutable-less": "static-1.5189",
  "marketplace-ui-client-types": "static-1.18571",
  "nav-meta": "static-1.30971",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18613",
  "ui-product-approvals-common": "static-1.1819",
  "ai-studio-lib": "static-1.12927",
  "hubspot-prosemirror": "static-1.19411",
  "integrations-reconnect-lib": "static-1.827",
  "ui-addon-iframeable": "static-1.9622",
  "ui-addon-integrations-directory-panel": "static-2.8491",
  "ui-product-approvals": "static-1.29923",
  "ui-tool-access": "static-1.10697",
  "data-agent-kit": "static-1.1058",
  "inbound-db-properties-service-client": "static-1.4191",
  "property-management-common": "static-1.6910",
  "smart-property-fill-lib": "static-1.881",
  "opentelemetry-fe-types": "static-1.342",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.622",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.717",
  "quartz-auth": "static-1.1443",
  "quartz-test": "static-1.1443",
  "quartz-tracking": "static-1.1147",
  "trellis-components": "static-1.3290",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.617",
  "HubStyle": "static-2.12338",
  "bender-build-tools": "static-1.3648",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24298",
  "ContentUtils": "static-1.69627",
  "customer-data-objects-ui-components": "static-1.13577",
  "sassPrefix": "static-1.429",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2093",
  "bend-plugin-pulse": "static-1.714",
  "event-emitter": "static-1.1500",
  "fast-json-patch": "static-1.79",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5965",
  "magpie-types": "static-1.5425",
  "stylex-utils": "static-1.193",
  "trellis-theming": "static-1.1587",
  "avatar-components": "static-1.3029",
  "breeze-engine-core": "static-1.1675",
  "breeze-engine-lib": "static-1.2397",
  "breeze-onboarding-components": "static-1.1218",
  "breeze-upgrade-component-lib": "static-1.57",
  "customer-data-filters-ui": "static-1.41562",
  "customer-data-reference-ui-components": "static-1.13717",
  "data-integrations-breeze": "static-1.564",
  "embedded-academy-lib": "static-1.16226",
  "ExportDialog": "static-6.10915",
  "global-styles-ai-lib": "static-1.608",
  "highlight.js": "static-1.93",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.1021",
  "mermaid": "static-1.48",
  "reporting-action-components": "static-1.42536",
  "reporting-snowflake": "static-1.58269",
  "reporting-ui-components": "static-2.66922",
  "reporting-visualizations": "static-1.61727",
  "trial-components-library": "static-1.14489",
  "ui-addon-teams": "static-1.22080",
  "upgrade-components-lib": "static-1.800",
  "navigation-components": "static-1.19334",
  "nest": "static-1.781",
  "simple-logging-lib": "static-1.3589",
  "nudge-client-utils": "static-1.3517",
  "fail-safe": "static-1.488",
  "app-governance-lib": "static-1.2851",
  "developer-experience-shared-components": "static-1.11087",
  "purchase-motions-components": "static-1.6727",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10987",
  "usage-tracker-anonymous": "static-1.6303",
  "usage-tracker-public": "static-1.7697",
  "amplitude-session-replay-browser": "static-1.80",
  "inbound-db-meta-service-client": "static-1.3811",
  "persist-promise": "static-1.4250",
  "reference-resolvers": "static-1.8727",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4459",
  "hubspot-apollo-cache": "static-1.876",
  "universal-page-editor-lib": "static-1.3562",
  "final-form": "static-1.86",
  "redux-toolkit": "static-1.85",
  "simple-data-table": "static-1.3947",
  "merchandise-lib": "static-1.291",
  "onboarding-scopes": "static-1.6993",
  "permissions-summary-ui-lib": "static-1.177",
  "ui-addon-draggable": "static-3.5294",
  "content-assistance-lib": "static-1.8509",
  "content-media-capture": "static-1.5895",
  "customer-data-ui-utilities": "static-1.10375",
  "emoji-mart": "static-3.10",
  "file-manager-components": "static-1.24943",
  "growth-payments-core": "static-1.26635",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3417",
  "payment-link-components": "static-1.24594",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20652",
  "ui-addon-emoji-picker": "static-1.10406",
  "ui-business-units-lib": "static-1.9637",
  "video-components-external": "static-1.12560",
  "video-data-lib": "static-1.36218",
  "navigation-messaging": "static-1.8661",
  "collaboration-sidebar": "static-1.59180",
  "trellis-ext-dnd": "static-1.641",
  "policy-lib": "static-1.7344",
  "crm-component-utils": "static-1.40343",
  "crm-properties-common-lib": "static-1.6438",
  "customer-data-properties": "static-1.53261",
  "external-options-client-types": "static-1.4478",
  "hs-resources": "static-1.738",
  "property-value-citations": "static-1.3875",
  "reference-resolvers-lite": "static-1.8654",
  "access-check-ui-lib": "static-1.2075",
  "crm-message-bus": "static-1.44264",
  "data-agent-test-utils": "static-1.602",
  "data-agent-usage-based-billing": "static-1.245",
  "data-agent-utils": "static-1.1071",
  "enrichment-settings-lib": "static-1.419",
  "smart-property-lib": "static-1.8863",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11008",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "cms-field-types": "static-1.5354",
  "content-icons-ui": "static-1.2525",
  "atom": "static-1.5615",
  "idb-keyval": "static-1.59",
  "reactive-lib": "static-1.1263",
  "trellis-migration-context": "static-1.120",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1375",
  "breeze-artifacts-sdk": "static-1.1226",
  "breeze-assistant-components": "static-1.2786",
  "getting-started-shared-tasks": "static-1.19670",
  "onboarding-journeys-lib": "static-1.1360",
  "interactive-cards": "static-1.625",
  "conversations-skeleton-state": "static-1.7655",
  "customer-data-filters-ui-msw-helpers": "static-1.23997",
  "events-data-lib": "static-1.796",
  "FormUrlGenerator": "static-2.5254",
  "framework-builder-read-service-client": "static-1.4374",
  "multi-account-reference-resolvers": "static-1.1562",
  "onboarding-tours": "static-1.17488",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14881",
  "segments-client-types": "static-1.12402",
  "academy-common-lib": "static-1.15687",
  "dashboard-lib": "static-1.83471",
  "hubspot-prosemirror-plugins": "static-1.19403",
  "reporting-plugins": "static-1.11108",
  "share-with-third-party-component-lib": "static-1.9255",
  "ui-addon-draggable-compat": "static-2.4801",
  "ui-asset-management-lib": "static-1.11653",
  "user-context": "static-1.5598",
  "reporting-reports": "static-1.69329",
  "hubs-service-types": "static-1.1808",
  "purchase-motions-api": "static-1.6730",
  "salesImages": "static-1.799",
  "signup-constants": "static-1.20124",
  "nudge-custom-function-registry": "static-1.3274",
  "nudge-renderer-utils": "static-1.3593",
  "whisper-core-api": "static-1.7747",
  "bend-plugin-fail-safe": "static-1.439",
  "framework-listing-lib": "static-2.29956",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31885",
  "apps-service-types": "static-1.4149",
  "oauth-service-types": "static-1.4677",
  "signup-ui-url-generator": "static-2.8577",
  "onboarding-tours-client": "static-1.5703",
  "one-click-checkout": "static-1.883",
  "platform-infra-nav-components": "static-1.8041",
  "purchasing-components-lib": "static-1.1128",
  "subscription-experience-data-types": "static-1.15524",
  "crm-record-cards-client": "static-1.239",
  "crm-record-cards-service-types": "static-1.3897",
  "framework-data-schema-resolvers": "static-1.7432",
  "location-customization-utils-lib": "static-1.10565",
  "redux-thunk": "static-2.88",
  "seat-types-lib": "static-1.1179",
  "react-flip-move": "static-1.86",
  "ui-coaching-tips": "static-1.29645",
  "content-media-composition-data-lib": "static-1.13700",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4970",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.4017",
  "ui-addon-opt": "static-4.8978",
  "commerce-tours-lib": "static-1.6955",
  "growth-onboarding-reliability": "static-1.5624",
  "sales-checkout-service-client": "static-1.4062",
  "data-token-picker": "static-1.17229",
  "FileManagerLib": "static-1.40584",
  "content-media-compositions": "static-2.17707",
  "media-bridge-lib": "static-1.19735",
  "chatspot-widget-iframe": "static-1.24289",
  "collaboration-sidebar-common": "static-1.3977",
  "marketing-platform-lib": "static-1.7453",
  "dnd-kit": "static-1.24",
  "commerce-subscription-lib": "static-1.38175",
  "crm-actions": "static-1.6957",
  "crm-cards-sdk": "static-1.45210",
  "customer-data-properties-shared-msw-handlers": "static-1.10337",
  "customer-data-tracking": "static-1.7412",
  "calling-global-api": "static-1.66534",
  "calling-internal-common": "static-1.31864",
  "calling-lifecycle-internal": "static-1.67916",
  "calling-lifecycle-messages": "static-1.60208",
  "commerce-products-lib": "static-1.11102",
  "conditional-properties-service-client": "static-1.4152",
  "crm-index-visualization-core": "static-1.4854",
  "crm-links": "static-1.6870",
  "crm-pipelines-api-client-types": "static-1.4485",
  "formula-editor": "static-1.15088",
  "google-libphonenumber": "static-1.53",
  "inbounddb-objects-service-types": "static-1.4556",
  "meetings-icalendar-utils-lib": "static-1.1177",
  "multi-currency-client-types": "static-1.4050",
  "object-builder-ui-client": "static-1.50230",
  "pipeline-validation-client-types": "static-1.4323",
  "react-tinymce": "static-1.56381",
  "smart-data-capture-core": "static-1.623",
  "tiered-pricing": "static-1.2393",
  "tinymce-config": "static-2.55507",
  "tinymce-plugins": "static-1.58621",
  "tinymce-themes": "static-1.57477",
  "topics-actions-lib": "static-1.735",
  "trellis-ext-i18n": "static-1.1485",
  "ui-addon-form-validation": "static-1.11355",
  "zustand": "static-1.93",
  "fdsr-migration-layer": "static-1.556",
  "permissions-shared-i18n-strings-fe": "static-1.2146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11093",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11156",
  "sales-views-client-types": "static-1.4800",
  "breeze-sharing-core": "static-1.105",
  "dompurify": "static-1.17",
  "utility-belt": "static-1.3077",
  "growth-data-modal": "static-1.6223",
  "growth-onboarding-confetti": "static-1.3598",
  "growth-onboarding-next-action-utils": "static-1.3106",
  "onboarding-tours-utils": "static-1.1555",
  "ui-shepherd-tracker": "static-1.8210",
  "crm-index-associations-lib": "static-1.6992",
  "academy-service-client": "static-1.4235",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40443",
  "SafeStorage": "static-1.4936",
  "video-embed": "static-1.37052",
  "redux-actions": "static-3.78",
  "EmailSignatureEditor": "static-1.25354",
  "viral-links-lib": "static-1.7625",
  "campaign-roi-lib": "static-1.11034",
  "campaigns-utils-lib": "static-1.3813",
  "ui-addon-calendars": "static-2.5915",
  "nested-table": "static-1.764",
  "timezone-utils": "static-2.5767",
  "getting-started-shared-tasks-store": "static-1.18788",
  "customer-data-views-management": "static-1.26467",
  "framework-data-table": "static-2.12953",
  "nudge-custom-ui-functions": "static-1.1825",
  "switchboard-lib": "static-1.788",
  "app-users-service-client": "static-1.6161",
  "app-users-service-types": "static-1.5569",
  "mini-checkout-client": "static-1.27978",
  "onboarding-utils": "static-1.5917",
  "ui-coaching-tips-shared-config": "static-1.29630",
  "checkout-sdk": "static-3.24821",
  "payment-method-components": "static-1.7381",
  "touchless-buying-components": "static-1.6689",
  "upgrade-catalog-service-types": "static-1.3908",
  "pricing-pages-ui-components": "static-1.16844",
  "edison-service-client-types": "static-1.933",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "growth-onboarding-feedback-components": "static-1.7126",
  "audio-components": "static-1.6657",
  "FileManagerImages": "static-1.38095",
  "video-components": "static-1.14562",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20628",
  "commerce-shared-components-lib": "static-1.19704",
  "commerce-tools-ui-lib": "static-1.11439",
  "crm_data": "static-4.93368",
  "crm-activity-creator-data": "static-1.47926",
  "crm-fe-perf": "static-1.23443",
  "universal-record-utils-lib": "static-1.2511",
  "calling-error-reporting": "static-1.31871",
  "shared-worker-versioning": "static-1.11582",
  "calling-usage-tracker": "static-1.7083",
  "voice-sms-access-library": "static-1.2620",
  "commerce-permissions": "static-1.1323",
  "products-iframe-lib": "static-1.9063",
  "products-ui-components-shared-msw-handlers": "static-1.11392",
  "bark-lib": "static-1.17076",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3571",
  "interframe": "static-3.5286",
  "tinymce-data": "static-1.41592",
  "ui-addon-sales-email": "static-1.5749",
  "layout-dnd-components": "static-1.13325",
  "layout-dnd-utils": "static-1.12300",
  "ui-brand-identity-lib": "static-1.17107",
  "NamespacedHubStyle": "static-2.9410",
  "onboarding-data-sync-lib": "static-1.2928",
  "growth-onboarding-next-action-components": "static-1.3134",
  "user-context-client": "static-1.5049",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.70",
  "urlinator": "static-1.5059",
  "outpost": "static-1.4666",
  "draft-convert": "static-2.88",
  "draft-extend": "static-3.91",
  "draft-js": "static-5.93",
  "draft-plugins": "static-2.22456",
  "sales-email-signature-service-client": "static-1.4388",
  "copilot-messaging": "static-1.2525",
  "ts-utils-lib": "static-1.696",
  "crm-export-dialog": "static-1.6820",
  "crm-index-ui-shimmer": "static-1.3141",
  "crm-view-components": "static-1.1661",
  "react-beautiful-dnd": "static-1.78",
  "customer-data-associations": "static-1.7885",
  "tasks-actions-lib": "static-1.572",
  "InboxConnectUtils": "static-4.15964",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.897",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4532",
  "company-details-components": "static-1.6751",
  "react-performance-metrics-lib": "static-1.1093",
  "quote-checkout-service-types": "static-1.4001",
  "pricing-pages-api": "static-1.16710",
  "social-insights-client-types": "static-1.23051",
  "crm-command-handler-types": "static-1.202",
  "payments-enrollment-embed-lib": "static-1.24411",
  "stripe-embedded-components": "static-1.8341",
  "customer-data-rte": "static-1.34007",
  "cv-backend-services": "static-1.1622",
  "growth-onboarding-empty-states": "static-1.6634",
  "payments-post-enroll-local-storage-lib": "static-1.5641",
  "qrcode-generator": "static-1.83",
  "quotes-client-types": "static-1.39300",
  "crm_universal": "static-1.22817",
  "customer-data-email": "static-1.18741",
  "meetings-rte-lib": "static-1.644",
  "universal-associations-select": "static-1.11646",
  "crm-object-search-query-utilities": "static-1.10573",
  "calling-orchestration-schema": "static-1.37397",
  "react-reducer-toolkit": "static-1.16780",
  "ContentData": "static-1.69702",
  "layout-data-lib": "static-1.10625",
  "meetings-connect-utils-lib": "static-1.8160",
  "company-details-service-types": "static-1.4481",
  "segments-query-core": "static-1.1967",
  "stripe-connect-js": "static-1.86",
  "draft-content-plugins": "static-1.29259",
  "sequences-lib": "static-1.8876",
  "ui-gdpr-components": "static-1.10659",
  "meetings-client-types": "static-1.4130",
  "meetings-core": "static-1.866",
  "advanced-menus-core": "static-1.15915",
  "advanced-menus-lib": "static-1.12643",
  "ui-memberships-settings-lib": "static-1.35337",
  "sequences-client-types-lib": "static-1.8733",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15914",
  "simple-menus-lib": "static-1.17431"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13622",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1340",
  "client-types": "/client-types/static-1.524",
  "data-fetching-client": "/data-fetching-client/static-1.10177",
  "foundations-components": "/foundations-components/static-1.8854",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1879",
  "foundations-theming": "/foundations-theming/static-1.5043",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.96",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8583",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11010",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12031",
  "I18n": "/I18n/static-7.1726",
  "jasmine-runner": "/jasmine-runner/static-1.7000",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.1011",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13685",
  "quartz": "/quartz/static-1.7768",
  "react-dlb": "/react-dlb/static-1.97",
  "react-rhumb": "/react-rhumb/static-1.17281",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3391",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11586",
  "reselect": "/reselect/static-3.20",
  "settings-ui-lib": "/settings-ui-lib/static-1.13074",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7944",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11690",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10070",
  "unified-auth": "/unified-auth/static-1.1384",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1666",
  "usage-tracker": "/usage-tracker/static-1.7886",
  "usage-tracker-core": "/usage-tracker-core/static-1.7736",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8601",
  "hub-http": "/hub-http/static-1.6745",
  "integrations-lib": "/integrations-lib/static-1.17568",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21164",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1150",
  "property-management-iframe": "/property-management-iframe/static-1.14622",
  "quartz-config": "/quartz-config/static-1.1546",
  "quartz-core": "/quartz-core/static-1.6987",
  "quartz-routing": "/quartz-routing/static-1.1198",
  "quick-fetch": "/quick-fetch/static-1.4268",
  "react": "/react/static-7.206",
  "rpc-client-utils": "/rpc-client-utils/static-1.5207",
  "ts-schema": "/ts-schema/static-1.4435",
  "ui-universal-auth": "/ui-universal-auth/static-1.9870",
  "UIComponents": "/UIComponents/static-3.8977",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.529",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4045",
  "quartz-webpack": "/quartz-webpack/static-1.3992",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.846",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10137",
  "codemirror": "/codemirror/static-5.109",
  "foundations-assets": "/foundations-assets/static-1.5431",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "pulse": "/pulse/static-1.1211",
  "react-codemirror": "/react-codemirror/static-1.11183",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1125",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5123",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2759",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-story-utils": "/hs-story-utils/static-1.9966",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.124",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5721",
  "react-virtualized": "/react-virtualized/static-2.115",
  "StyleGuideUI": "/StyleGuideUI/static-3.522",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3271",
  "ui-fonts": "/ui-fonts/static-1.1293",
  "ui-images": "/ui-images/static-2.1297",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3526",
  "foundations-theming-base": "/foundations-theming-base/static-1.4028",
  "stylex": "/stylex/static-1.50",
  "HeadJS": "/HeadJS/static-2.839",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3694",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.45",
  "testing-library": "/testing-library/static-1.168",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4846",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9163",
  "ai-rendering-library": "/ai-rendering-library/static-1.11557",
  "chirp-fetch": "/chirp-fetch/static-1.2441",
  "connections-embed-lib": "/connections-embed-lib/static-1.1854",
  "copilot-toolkit": "/copilot-toolkit/static-1.12274",
  "feedback-loader": "/feedback-loader/static-1.30155",
  "laboratory-lib": "/laboratory-lib/static-3.7690",
  "marketplace-embed": "/marketplace-embed/static-1.23318",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.11059",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21119",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15334",
  "sanitize-text": "/sanitize-text/static-1.8698",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6300",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5572",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.244",
  "quartz-head": "/quartz-head/static-1.1433",
  "web-vitals": "/web-vitals/static-1.22",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5130",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4686",
  "highcharts": "/highcharts/static-8.118",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2904",
  "reporting-data": "/reporting-data/static-1.69653",
  "cssUtils": "/cssUtils/static-1.1163",
  "flux-actions": "/flux-actions/static-1.384",
  "react-colorpicker": "/react-colorpicker/static-2.10751",
  "react-dnd-compat": "/react-dnd-compat/static-1.5152",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10914",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7876",
  "icons": "/icons/static-2.717",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19696",
  "storybook-react": "/storybook-react/static-1.47",
  "trellis-story-utils": "/trellis-story-utils/static-1.5037",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6337",
  "quartz-i18n": "/quartz-i18n/static-1.1443",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.854",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2318",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.87",
  "cohere-settings-lib": "/cohere-settings-lib/static-1.10554",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.434",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9904",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1453",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.651",
  "slack-ui-library": "/slack-ui-library/static-1.10944",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.967",
  "x-ai-settings-lib": "/x-ai-settings-lib/static-1.10612",
  "fsm": "/fsm/static-1.4302",
  "customer-data-objects": "/customer-data-objects/static-1.8257",
  "property-translator": "/property-translator/static-1.5916",
  "hs-locale-management": "/hs-locale-management/static-1.444",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8464",
  "hs-promise-utils": "/hs-promise-utils/static-1.6133",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5417",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14983",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6170",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8300",
  "sanitize": "/sanitize/static-1.5009",
  "superstore": "/superstore/static-1.5296",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10829",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8692",
  "hub-http-janus": "/hub-http-janus/static-1.921",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "immutable-less": "/immutable-less/static-1.5189",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18571",
  "nav-meta": "/nav-meta/static-1.30971",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18613",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1819",
  "ai-studio-lib": "/ai-studio-lib/static-1.12927",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19411",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.827",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9622",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8491",
  "ui-product-approvals": "/ui-product-approvals/static-1.29923",
  "ui-tool-access": "/ui-tool-access/static-1.10697",
  "data-agent-kit": "/data-agent-kit/static-1.1058",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4191",
  "property-management-common": "/property-management-common/static-1.6910",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.881",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.342",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.622",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.717",
  "quartz-auth": "/quartz-auth/static-1.1443",
  "quartz-test": "/quartz-test/static-1.1443",
  "quartz-tracking": "/quartz-tracking/static-1.1147",
  "trellis-components": "/trellis-components/static-1.3290",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.617",
  "HubStyle": "/HubStyle/static-2.12338",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24298",
  "ContentUtils": "/ContentUtils/static-1.69627",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13577",
  "sassPrefix": "/sassPrefix/static-1.429",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2093",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.714",
  "event-emitter": "/event-emitter/static-1.1500",
  "fast-json-patch": "/fast-json-patch/static-1.79",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5965",
  "magpie-types": "/magpie-types/static-1.5425",
  "stylex-utils": "/stylex-utils/static-1.193",
  "trellis-theming": "/trellis-theming/static-1.1587",
  "avatar-components": "/avatar-components/static-1.3029",
  "breeze-engine-core": "/breeze-engine-core/static-1.1675",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2397",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1218",
  "breeze-upgrade-component-lib": "/breeze-upgrade-component-lib/static-1.57",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41562",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13717",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.564",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16226",
  "ExportDialog": "/ExportDialog/static-6.10915",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.608",
  "highlight.js": "/highlight.js/static-1.93",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.1021",
  "mermaid": "/mermaid/static-1.48",
  "reporting-action-components": "/reporting-action-components/static-1.42536",
  "reporting-snowflake": "/reporting-snowflake/static-1.58269",
  "reporting-ui-components": "/reporting-ui-components/static-2.66922",
  "reporting-visualizations": "/reporting-visualizations/static-1.61727",
  "trial-components-library": "/trial-components-library/static-1.14489",
  "ui-addon-teams": "/ui-addon-teams/static-1.22080",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.800",
  "navigation-components": "/navigation-components/static-1.19334",
  "nest": "/nest/static-1.781",
  "simple-logging-lib": "/simple-logging-lib/static-1.3589",
  "nudge-client-utils": "/nudge-client-utils/static-1.3517",
  "fail-safe": "/fail-safe/static-1.488",
  "app-governance-lib": "/app-governance-lib/static-1.2851",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11087",
  "purchase-motions-components": "/purchase-motions-components/static-1.6727",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10987",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6303",
  "usage-tracker-public": "/usage-tracker-public/static-1.7697",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3811",
  "persist-promise": "/persist-promise/static-1.4250",
  "reference-resolvers": "/reference-resolvers/static-1.8727",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4459",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.876",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3562",
  "final-form": "/final-form/static-1.86",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "simple-data-table": "/simple-data-table/static-1.3947",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "onboarding-scopes": "/onboarding-scopes/static-1.6993",
  "permissions-summary-ui-lib": "/permissions-summary-ui-lib/static-1.177",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5294",
  "content-assistance-lib": "/content-assistance-lib/static-1.8509",
  "content-media-capture": "/content-media-capture/static-1.5895",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10375",
  "emoji-mart": "/emoji-mart/static-3.10",
  "file-manager-components": "/file-manager-components/static-1.24943",
  "growth-payments-core": "/growth-payments-core/static-1.26635",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3417",
  "payment-link-components": "/payment-link-components/static-1.24594",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20652",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10406",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9637",
  "video-components-external": "/video-components-external/static-1.12560",
  "video-data-lib": "/video-data-lib/static-1.36218",
  "navigation-messaging": "/navigation-messaging/static-1.8661",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59180",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.641",
  "policy-lib": "/policy-lib/static-1.7344",
  "crm-component-utils": "/crm-component-utils/static-1.40343",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6438",
  "customer-data-properties": "/customer-data-properties/static-1.53261",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "hs-resources": "/hs-resources/static-1.738",
  "property-value-citations": "/property-value-citations/static-1.3875",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8654",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.2075",
  "crm-message-bus": "/crm-message-bus/static-1.44264",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.602",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.245",
  "data-agent-utils": "/data-agent-utils/static-1.1071",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.419",
  "smart-property-lib": "/smart-property-lib/static-1.8863",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11008",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "cms-field-types": "/cms-field-types/static-1.5354",
  "content-icons-ui": "/content-icons-ui/static-1.2525",
  "atom": "/atom/static-1.5615",
  "idb-keyval": "/idb-keyval/static-1.59",
  "reactive-lib": "/reactive-lib/static-1.1263",
  "trellis-migration-context": "/trellis-migration-context/static-1.120",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1375",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1226",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2786",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19670",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1360",
  "interactive-cards": "/interactive-cards/static-1.625",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7655",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23997",
  "events-data-lib": "/events-data-lib/static-1.796",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5254",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1562",
  "onboarding-tours": "/onboarding-tours/static-1.17488",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14881",
  "segments-client-types": "/segments-client-types/static-1.12402",
  "academy-common-lib": "/academy-common-lib/static-1.15687",
  "dashboard-lib": "/dashboard-lib/static-1.83471",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19403",
  "reporting-plugins": "/reporting-plugins/static-1.11108",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9255",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4801",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11653",
  "user-context": "/user-context/static-1.5598",
  "reporting-reports": "/reporting-reports/static-1.69329",
  "hubs-service-types": "/hubs-service-types/static-1.1808",
  "purchase-motions-api": "/purchase-motions-api/static-1.6730",
  "salesImages": "/salesImages/static-1.799",
  "signup-constants": "/signup-constants/static-1.20124",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3274",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3593",
  "whisper-core-api": "/whisper-core-api/static-1.7747",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.439",
  "framework-listing-lib": "/framework-listing-lib/static-2.29956",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31885",
  "apps-service-types": "/apps-service-types/static-1.4149",
  "oauth-service-types": "/oauth-service-types/static-1.4677",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8577",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5703",
  "one-click-checkout": "/one-click-checkout/static-1.883",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8041",
  "purchasing-components-lib": "/purchasing-components-lib/static-1.1128",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15524",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.239",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3897",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "redux-thunk": "/redux-thunk/static-2.88",
  "seat-types-lib": "/seat-types-lib/static-1.1179",
  "react-flip-move": "/react-flip-move/static-1.86",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29645",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13700",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4970",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.4017",
  "ui-addon-opt": "/ui-addon-opt/static-4.8978",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6955",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5624",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4062",
  "data-token-picker": "/data-token-picker/static-1.17229",
  "FileManagerLib": "/FileManagerLib/static-1.40584",
  "content-media-compositions": "/content-media-compositions/static-2.17707",
  "media-bridge-lib": "/media-bridge-lib/static-1.19735",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24289",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3977",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7453",
  "dnd-kit": "/dnd-kit/static-1.24",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38175",
  "crm-actions": "/crm-actions/static-1.6957",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45210",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10337",
  "customer-data-tracking": "/customer-data-tracking/static-1.7412",
  "calling-global-api": "/calling-global-api/static-1.66534",
  "calling-internal-common": "/calling-internal-common/static-1.31864",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67916",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60208",
  "commerce-products-lib": "/commerce-products-lib/static-1.11102",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4152",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4854",
  "crm-links": "/crm-links/static-1.6870",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4485",
  "formula-editor": "/formula-editor/static-1.15088",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4556",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1177",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4050",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50230",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4323",
  "react-tinymce": "/react-tinymce/static-1.56381",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.623",
  "tiered-pricing": "/tiered-pricing/static-1.2393",
  "tinymce-config": "/tinymce-config/static-2.55507",
  "tinymce-plugins": "/tinymce-plugins/static-1.58621",
  "tinymce-themes": "/tinymce-themes/static-1.57477",
  "topics-actions-lib": "/topics-actions-lib/static-1.735",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1485",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11355",
  "zustand": "/zustand/static-1.93",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.556",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11093",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11156",
  "sales-views-client-types": "/sales-views-client-types/static-1.4800",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.105",
  "dompurify": "/dompurify/static-1.17",
  "utility-belt": "/utility-belt/static-1.3077",
  "growth-data-modal": "/growth-data-modal/static-1.6223",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3598",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3106",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1555",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8210",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6992",
  "academy-service-client": "/academy-service-client/static-1.4235",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40443",
  "SafeStorage": "/SafeStorage/static-1.4936",
  "video-embed": "/video-embed/static-1.37052",
  "redux-actions": "/redux-actions/static-3.78",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25354",
  "viral-links-lib": "/viral-links-lib/static-1.7625",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.11034",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3813",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5915",
  "nested-table": "/nested-table/static-1.764",
  "timezone-utils": "/timezone-utils/static-2.5767",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18788",
  "customer-data-views-management": "/customer-data-views-management/static-1.26467",
  "framework-data-table": "/framework-data-table/static-2.12953",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1825",
  "switchboard-lib": "/switchboard-lib/static-1.788",
  "app-users-service-client": "/app-users-service-client/static-1.6161",
  "app-users-service-types": "/app-users-service-types/static-1.5569",
  "mini-checkout-client": "/mini-checkout-client/static-1.27978",
  "onboarding-utils": "/onboarding-utils/static-1.5917",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29630",
  "checkout-sdk": "/checkout-sdk/static-3.24821",
  "payment-method-components": "/payment-method-components/static-1.7381",
  "touchless-buying-components": "/touchless-buying-components/static-1.6689",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3908",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16844",
  "edison-service-client-types": "/edison-service-client-types/static-1.933",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7126",
  "audio-components": "/audio-components/static-1.6657",
  "FileManagerImages": "/FileManagerImages/static-1.38095",
  "video-components": "/video-components/static-1.14562",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20628",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19704",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11439",
  "crm_data": "/crm_data/static-4.93368",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47926",
  "crm-fe-perf": "/crm-fe-perf/static-1.23443",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2511",
  "calling-error-reporting": "/calling-error-reporting/static-1.31871",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11582",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7083",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2620",
  "commerce-permissions": "/commerce-permissions/static-1.1323",
  "products-iframe-lib": "/products-iframe-lib/static-1.9063",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11392",
  "bark-lib": "/bark-lib/static-1.17076",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3571",
  "interframe": "/interframe/static-3.5286",
  "tinymce-data": "/tinymce-data/static-1.41592",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5749",
  "layout-dnd-components": "/layout-dnd-components/static-1.13325",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12300",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17107",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9410",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2928",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3134",
  "user-context-client": "/user-context-client/static-1.5049",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.70",
  "urlinator": "/urlinator/static-1.5059",
  "outpost": "/outpost/static-1.4666",
  "draft-convert": "/draft-convert/static-2.88",
  "draft-extend": "/draft-extend/static-3.91",
  "draft-js": "/draft-js/static-5.93",
  "draft-plugins": "/draft-plugins/static-2.22456",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4388",
  "copilot-messaging": "/copilot-messaging/static-1.2525",
  "ts-utils-lib": "/ts-utils-lib/static-1.696",
  "crm-export-dialog": "/crm-export-dialog/static-1.6820",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3141",
  "crm-view-components": "/crm-view-components/static-1.1661",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.78",
  "customer-data-associations": "/customer-data-associations/static-1.7885",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.572",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15964",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.897",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4532",
  "company-details-components": "/company-details-components/static-1.6751",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1093",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.4001",
  "pricing-pages-api": "/pricing-pages-api/static-1.16710",
  "social-insights-client-types": "/social-insights-client-types/static-1.23051",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.202",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24411",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8341",
  "customer-data-rte": "/customer-data-rte/static-1.34007",
  "cv-backend-services": "/cv-backend-services/static-1.1622",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6634",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5641",
  "qrcode-generator": "/qrcode-generator/static-1.83",
  "quotes-client-types": "/quotes-client-types/static-1.39300",
  "crm_universal": "/crm_universal/static-1.22817",
  "customer-data-email": "/customer-data-email/static-1.18741",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.644",
  "universal-associations-select": "/universal-associations-select/static-1.11646",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10573",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37397",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16780",
  "ContentData": "/ContentData/static-1.69702",
  "layout-data-lib": "/layout-data-lib/static-1.10625",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8160",
  "company-details-service-types": "/company-details-service-types/static-1.4481",
  "segments-query-core": "/segments-query-core/static-1.1967",
  "stripe-connect-js": "/stripe-connect-js/static-1.86",
  "draft-content-plugins": "/draft-content-plugins/static-1.29259",
  "sequences-lib": "/sequences-lib/static-1.8876",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "meetings-client-types": "/meetings-client-types/static-1.4130",
  "meetings-core": "/meetings-core/static-1.866",
  "advanced-menus-core": "/advanced-menus-core/static-1.15915",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12643",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35337",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8733",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15914",
  "simple-menus-lib": "/simple-menus-lib/static-1.17431"
}
};
